"use strict";

require("../../style/index.less");

require("./index.less");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/checkbox/style/index.js
// module id = 76
// module chunks = 1